export default __webpack_public_path__ + "static/media/psn.408d5026.png";